module.exports = __webpack_public_path__ + "img/conferma_smartbook.a23419e3.png";